// @ts-strict-ignore
import { AlertHelper } from '@shared/alert/alert.helper';
import { FileUtils } from '@shared/util/file-utils';
import { RouteNavigationService } from '@services/route-navigation.service';
import { Injectable } from '@angular/core';
import { AlertButton } from '@shared/alert/alertButton';
import { ProjectModel } from '../../../model/project.model';
import { Log } from '@shared/debug/log';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';

@Injectable({ providedIn: 'root' })
export class ProServeProjectImportManager {
  public static readonly IMPORT_PROSERVE_PROJECT: string = 'importProServeProject';

  constructor(
    private alertHelper: AlertHelper,
    private routeNavigationService: RouteNavigationService,
    private projectModel: ProjectModel,
    private projectModelService: ProjectModelService,
    private projectNavigationPresenter: ProjectNavigationPresenter
  ) {}

  private importByLoadedFile(loadedFile: Document): void {
    this.projectNavigationPresenter.openImportProserveDialog(loadedFile);
  }

  private async loadProServeProjectXml(data: { navigateToConfigurator: boolean }): Promise<void> {
    let loadedFile: string;
    try {
      loadedFile = await FileUtils.loadTextFile('.xml');
    } catch (error) {
      FileUtils.handleFileLoadingError(error, this.alertHelper);
      return;
    }

    const parser = new DOMParser();
    const parseStringToXmlObject = parser.parseFromString(loadedFile, 'text/xml');
    if (data && data.navigateToConfigurator) {
      try {
        await this.routeNavigationService.toConfigurator();
        this.importByLoadedFile(parseStringToXmlObject);
      } catch (error) {
        Log.error('Could not navigate to configurator: ', error)
      }
    } else {
      this.importByLoadedFile(parseStringToXmlObject);
    }
  }

  public async importProServeProject(data: { navigateToConfigurator: boolean } | null): Promise<void> {
    if (this.projectModel.currentProjectRequiresSaving) {
      const answer = await this.alertHelper.showAlert('import_proserve_project.title.confirm_import_project',
          'import_proserve_project.message.confirm_import_project', null,
          [AlertButton.YES, AlertButton.NO], "error");
      if (answer === AlertButton.YES) {
        await this.projectModelService.clearCurrentProject();
        await this.loadProServeProjectXml(data);
      }
    } else {
      const answer = await this.alertHelper.showAlert('import_proserve_project.title.confirm_import_unchanged_project',
          'import_proserve_project.message.confirm_import_unchanged_project', null,
          [AlertButton.YES, AlertButton.NO], "error");
      if (answer === AlertButton.YES) {
        await this.projectModelService.clearCurrentProject();
        await this.loadProServeProjectXml(data);
      }
    }
  }
}
